export default __webpack_public_path__ + "static/media/Emojis10.18b29ede.png";